import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';
import type { SavedFlightsResponse } from '@/types/api';
import type { FlightSegment, SavedFlight } from '@shared/types';

export function useSavedFlights() {
  const [flights, setFlights] = useState<SavedFlight[]>([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(() => {
    api
      .get<SavedFlightsResponse>('/flights/saved')
      .then((res) => setFlights(res.flights))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(
    async (segment: FlightSegment, date: string) => {
      await api.post('/flights/saved', { segment, date });
      refresh();
    },
    [refresh],
  );

  const remove = useCallback(
    async (id: number) => {
      await api.del(`/flights/saved/${id}`);
      refresh();
    },
    [refresh],
  );

  return { flights, loading, save, remove, refresh };
}
